import {List, Map as ImmutableMap, OrderedMap, Set as ImmutableSet, OrderedSet, Stack, Seq} from 'immutable';

import {constructUsing} from 'rlink-collections/symbols';
import {isInstanceOrSubclassOf} from 'rlink-type-utils';

export default function constructsUsing (obj) {
  if (isInstanceOrSubclassOf(obj, List)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, ImmutableMap)) {
    return constructUsing.both;
  } else if (isInstanceOrSubclassOf(obj, OrderedMap)) {
    return constructUsing.both;
  } else if (isInstanceOrSubclassOf(obj, ImmutableSet)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, OrderedSet)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, Stack)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, Seq.Keyed)) {
    return constructUsing.both;
  } else if (isInstanceOrSubclassOf(obj, Seq.Indexed)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, Seq.Set)) {
    return constructUsing.value;
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/immutable/constructsUsing.js